"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageCaption = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var styled_components_1 = __importStar(require("styled-components"));
var Container_1 = require("../../layouts/Container");
var Section_1 = require("../../layouts/Section");
var imageCaptionCss = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* .lagom-image-caption */\n  &.lagom-section {\n    overflow: hidden;\n  }\n\n  .lagom-image-caption__block-img {\n    margin-bottom: 2rem;\n  }\n\n  .lagom-image-caption__block-img img {\n    width: 100%;\n    height: auto;\n  }\n\n  .lagom-image-caption__image-label {\n    display: block;\n    text-align: center;\n    font-style: italic;\n    font-size: 14px;\n    color: var(--lagom-semantic-color-fg-subtle);\n  }\n"], ["\n  /* .lagom-image-caption */\n  &.lagom-section {\n    overflow: hidden;\n  }\n\n  .lagom-image-caption__block-img {\n    margin-bottom: 2rem;\n  }\n\n  .lagom-image-caption__block-img img {\n    width: 100%;\n    height: auto;\n  }\n\n  .lagom-image-caption__image-label {\n    display: block;\n    text-align: center;\n    font-style: italic;\n    font-size: 14px;\n    color: var(--lagom-semantic-color-fg-subtle);\n  }\n"])));
var DefaultImageSection = (0, styled_components_1.default)(Section_1.Section)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), imageCaptionCss);
var DefaultImage = function (_a) {
    var className = _a.className, image = _a.image, caption = _a.caption;
    return ((0, jsx_runtime_1.jsx)(DefaultImageSection, { className: (0, clsx_1.default)("lagom-image-caption", className), children: (0, jsx_runtime_1.jsx)(Container_1.Container, { children: (0, jsx_runtime_1.jsxs)("figure", { className: "lagom-image-caption__block-img", children: [image, caption && caption !== "" ? ((0, jsx_runtime_1.jsx)("figcaption", { className: "lagom-image-caption__image-label", children: caption })) : null] }) }) }));
};
var EmphasizedImageSection = (0, styled_components_1.default)(Section_1.Section)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n\n  .lagom-image-caption--emphasized {\n    ", " {\n      width: 130%;\n      margin: 0 -15% 2rem -15%;\n    }\n  }\n"], ["\n  ", "\n\n  .lagom-image-caption--emphasized {\n    ", " {\n      width: 130%;\n      margin: 0 -15% 2rem -15%;\n    }\n  }\n"])), imageCaptionCss, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.emphasized;
});
var EmphasizedImage = function (_a) {
    var className = _a.className, image = _a.image, caption = _a.caption;
    return ((0, jsx_runtime_1.jsx)(EmphasizedImageSection, { className: (0, clsx_1.default)("lagom-image-caption", className), children: (0, jsx_runtime_1.jsx)(Container_1.Container, { children: (0, jsx_runtime_1.jsxs)("figure", { className: "lagom-image-caption__block-img lagom-image-caption--emphasized", children: [image, caption && caption !== "" ? ((0, jsx_runtime_1.jsx)("figcaption", { className: "lagom-image-caption__image-label", children: caption })) : null] }) }) }));
};
var FullWidthImageFigure = styled_components_1.default.figure(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n\n  &.lagom-image-caption--full-width {\n    max-height: 100vh;\n    margin-bottom: 8rem;\n\n    ", " {\n      margin-bottom: 4rem;\n    }\n  }\n\n  &.lagom-image-caption--full-width div {\n    max-height: 100vh;\n  }\n"], ["\n  ", "\n\n  &.lagom-image-caption--full-width {\n    max-height: 100vh;\n    margin-bottom: 8rem;\n\n    ", " {\n      margin-bottom: 4rem;\n    }\n  }\n\n  &.lagom-image-caption--full-width div {\n    max-height: 100vh;\n  }\n"])), imageCaptionCss, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.small;
});
var FullWidthImage = function (_a) {
    var className = _a.className, image = _a.image, caption = _a.caption;
    return ((0, jsx_runtime_1.jsxs)(FullWidthImageFigure, { className: (0, clsx_1.default)("lagom-image-caption lagom-image-caption__block-img lagom-image-caption--full-width", className), children: [(0, jsx_runtime_1.jsx)("div", { children: image }), caption && caption !== "" ? ((0, jsx_runtime_1.jsx)("figcaption", { className: "lagom-image-caption__image-label", children: caption })) : null] }));
};
var ImageCaption = function (_a) {
    var emphasized = _a.emphasized, fullwidth = _a.fullwidth, image = _a.image, restProps = __rest(_a, ["emphasized", "fullwidth", "image"]);
    if (!image)
        return null;
    if (emphasized)
        return (0, jsx_runtime_1.jsx)(EmphasizedImage, __assign({}, restProps, { image: image }));
    if (fullwidth)
        return (0, jsx_runtime_1.jsx)(FullWidthImage, __assign({}, restProps, { image: image }));
    return (0, jsx_runtime_1.jsx)(DefaultImage, __assign({}, restProps, { image: image }));
};
exports.ImageCaption = ImageCaption;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=ImageCaption.js.map